import EntityBadge from '../EntityBadge.jsx';
import { formatCurrency } from '../../lib/format.js';

export default function RecapTable({ recapByEntity = [], entityMap = {} }) {
  if (recapByEntity.length === 0) {
    return (
      <p className="text-sm text-slate-500 py-4 text-center">
        Aucune donnée à afficher pour cette période.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto -mx-1">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 bg-slate-50">
            <th className="text-left text-xs font-medium text-slate-500 px-3 py-2.5 sticky left-0 bg-slate-50 whitespace-nowrap">
              Entité
            </th>
            <th className="text-right text-xs font-medium text-slate-500 px-3 py-2.5 whitespace-nowrap">
              À recevoir
            </th>
            <th className="text-right text-xs font-medium text-slate-500 px-3 py-2.5 whitespace-nowrap">
              À payer
            </th>
            <th className="text-right text-xs font-medium text-slate-500 px-3 py-2.5 whitespace-nowrap">
              Solde net
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {recapByEntity.map((row) => {
            const entity = entityMap[row.entity_id];
            const net = (row.to_receive_cents ?? 0) - (row.to_pay_cents ?? 0);
            const netPositive = net >= 0;
            return (
              <tr key={row.entity_id} className="hover:bg-slate-50">
                <td className="px-3 py-2.5 sticky left-0 bg-white hover:bg-slate-50">
                  <EntityBadge slug={entity?.slug} name={entity?.name ?? row.entity_id} />
                  {entity?.name && (
                    <span className="ml-2 text-xs text-slate-600">{entity.name}</span>
                  )}
                </td>
                <td className="px-3 py-2.5 text-right tabular-nums text-emerald-700 font-medium whitespace-nowrap">
                  {formatCurrency(row.to_receive_cents ?? 0)}
                </td>
                <td className="px-3 py-2.5 text-right tabular-nums text-red-600 font-medium whitespace-nowrap">
                  {formatCurrency(row.to_pay_cents ?? 0)}
                </td>
                <td
                  className={`px-3 py-2.5 text-right tabular-nums font-semibold whitespace-nowrap ${
                    netPositive ? 'text-emerald-700' : 'text-red-600'
                  }`}
                >
                  {netPositive ? '+' : ''}{formatCurrency(net)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
